export default __webpack_public_path__ + "static/media/06.e4bfe3fe.svg";